import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const CityInput = ({name, label, options, load, rules=[], multiple=false, onChange=null, region_id=null, region_ids=null, subregion_id=null, subregion_ids=null, ...props}) => {

  // load cities
  useEffect(() => {
    load(1, 250, null, subregion_id ? {subregion_ids: subregion_id} : (subregion_ids ? {subregion_ids: subregion_ids} : null));
  }, [load, subregion_id, subregion_ids]);

  useEffect(() => {
    load(1, 250, null, region_id ? {region_ids: region_id} : (region_ids ? {region_ids: region_ids} : null));
  }, [load, region_id, region_ids]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select
            showSearch
            mode={multiple ? "multiple" : null}
            disabled={props.isLoading || props.isSubmitting}
            loading={props.isLoading}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={onChange}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default CityInput;
